import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useUpdateDocumentOnshoreOnly() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      key,
      onshoreOnly,
      notes,
    }: {
      key: string
      onshoreOnly: boolean
      notes: string
    }) => {
      const response = await apiClient.client.put({
        url: '/documents/{key}/onshore-only',
        path: { key },
        body: { onshore_only: onshoreOnly, notes },
        headers: { 'Content-Type': 'application/json' },
      })
      return response.data
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(
        apiClient.getDocumentDocumentsKeyGetOptions({
          path: { key: variables.key },
        }),
      )
    },
  })
}
